import { Injectable, RendererFactory2, Renderer2, Inject } from '@angular/core';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class StyleDirectionService {
  private _dirMode$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dirMode$: Observable<boolean> = this._dirMode$.asObservable();

  private _renderer: Renderer2;
  private head: HTMLElement;
  private themeLinksBootStrap: HTMLElement[] = [];

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) document: Document
  ) {
    this.head = document.head;
    this._renderer = rendererFactory.createRenderer(null, null);
  }

  public fillData(value: boolean) {
    this._dirMode$.next(value);

    this.dirMode$.subscribe(async (dirMode) => {
      if (dirMode) {
        // Load RTL Bootstrap when `dirMode` is true (Arabic)
        await this.bootstrapLoadCss('assets/css/bootstrap.rtl.css');
      } else {
        // Load LTR Bootstrap when `dirMode` is false (English, etc.)
        await this.bootstrapLoadCss('assets/css/bootstrap.css');
      }

      // Remove old Bootstrap links if there are more than one
      if (this.themeLinksBootStrap.length === 2) {
        this._renderer.removeChild(this.head, this.themeLinksBootStrap.shift());
      }
    });
  }

  private async bootstrapLoadCss(filename: string) {
    return new Promise((resolve) => {
      const linkEl: HTMLElement = this._renderer.createElement('link');
      this._renderer.setAttribute(linkEl, 'rel', 'stylesheet');
      this._renderer.setAttribute(linkEl, 'type', 'text/css');
      this._renderer.setAttribute(linkEl, 'href', filename);
      this._renderer.setProperty(linkEl, 'onload', resolve);
      this._renderer.appendChild(this.head, linkEl);
      this.themeLinksBootStrap = [...this.themeLinksBootStrap, linkEl];
    });
  }
}
